export const formHelperTextLocale = {
    errorIconTitle: 'Error:',
};
//# sourceMappingURL=FormHelperText.locale.mjs.mjs.map